function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import HeaderContainer from './HeaderContainer';
import HeaderLink from './HeaderLink';
import HeaderLinks from './HeaderLinks';
import Badge from '../Badge';
import Logo from '../Logo';
import { Grid, Row, Col } from '../Layout';

require('xps-style/core/header.css');

var propTypes = {
  className: PropTypes.string,

  /** Menu links array */
  links: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  /* navbar theme conditional qualifier */
  theme: PropTypes.oneOf(['dark', 'light']),
  logo: PropTypes.func,

  /** Select logo type: single, double, centered */
  logoType: PropTypes.oneOf(['single', 'double', 'centered']),

  /** Application title or name */
  appTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** Custom component displayed next to the app title */
  SecondaryTitleComponent: PropTypes.func,

  /** Set height of the Header bar */
  height: PropTypes.number,
  content: PropTypes.func,
  searchArea: PropTypes.func,
  fullWidth: PropTypes.bool
};
var defaultProps = {
  theme: 'dark',
  logoType: 'double',
  height: 72
};

var HeaderBar = function HeaderBar(_ref) {
  var className = _ref.className,
      links = _ref.links,
      theme = _ref.theme,
      logo = _ref.logo,
      logoType = _ref.logoType,
      appTitle = _ref.appTitle,
      SecondaryTitleComponent = _ref.SecondaryTitleComponent,
      content = _ref.content,
      searchArea = _ref.searchArea,
      height = _ref.height,
      fullWidth = _ref.fullWidth;
  var mLinks = [];

  if (Array.isArray(links)) {
    mLinks = links;
  } else if (_typeof(links) === 'object' && links.props) {
    mLinks = links.props.children;
  }

  var logoColor = theme === 'dark' ? 'white' : 'green';
  var ntClass = cx(_defineProperty({}, "header-skin--".concat(theme), true));
  var headerClass = cx({
    header__main: true
  }, className);
  return /*#__PURE__*/React.createElement(HeaderContainer, {
    theme: theme,
    className: ntClass
  }, /*#__PURE__*/React.createElement(Grid, {
    fluid: fullWidth
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: headerClass,
    style: {
      height: height
    }
  }, logo ? logo() : /*#__PURE__*/React.createElement(Logo, {
    color: logoColor,
    logoType: logoType,
    className: "header__logo",
    height: height
  }), appTitle ? /*#__PURE__*/React.createElement("div", {
    className: "app__title display-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", null, appTitle)) : null, SecondaryTitleComponent ? /*#__PURE__*/React.createElement("div", {
    className: "app__secondary-title display-flex align-items-center"
  }, SecondaryTitleComponent()) : null, /*#__PURE__*/React.createElement("div", {
    className: "spacer flex-grow-1"
  }), /*#__PURE__*/React.createElement(HeaderLinks, null, React.Children.map(mLinks, function (menulink) {
    return /*#__PURE__*/React.createElement(HeaderLink, {
      key: menulink.props.name,
      href: menulink.props.href,
      routerLink: menulink.props.routerLink,
      onClick: menulink.props.onClick
    }, menulink.props.name, menulink.props.badge !== undefined ? /*#__PURE__*/React.createElement(Badge, {
      value: menulink.props.badge,
      type: menulink.props.badgeType,
      badgeContext: menulink.props.badgeContext
    }) : null);
  })), searchArea ? searchArea() : null, content ? content() : null)))));
};

HeaderBar.propTypes = propTypes;
HeaderBar.defaultProps = defaultProps;
HeaderBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HeaderBar",
  "props": {
    "theme": {
      "defaultValue": {
        "value": "'dark'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "logoType": {
      "defaultValue": {
        "value": "'double'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'single'",
          "computed": false
        }, {
          "value": "'double'",
          "computed": false
        }, {
          "value": "'centered'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Select logo type: single, double, centered"
    },
    "height": {
      "defaultValue": {
        "value": "72",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Set height of the Header bar"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "links": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": "Menu links array"
    },
    "logo": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "appTitle": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Application title or name"
    },
    "SecondaryTitleComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom component displayed next to the app title"
    },
    "content": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "searchArea": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "fullWidth": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
export default HeaderBar;